import React from 'react'

export const OrdersAPI5ClientCtx = React.createContext(null)
export const RestaurantsAPI5ClientCtxx = React.createContext(null)
export const PaymentsAPI2ClientCtx = React.createContext(null)

